import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: "Home" },
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  /** */
  {
    path: "/movies/:id?",
    name: "movies",
    meta: { title: "Movies" },
    component: () =>
      import(/*webpackChunkName: Movies */ "@/components/Movie/MovieC"),
  },
  {
    path: "/profile",
    name: "profile",
    component: () =>
      import(/*webpackChunkName: Movies */ "@/components/Movie/ProfileC"),
  },
  {
    path: "/search",
    name: "moviedetail",
    meta: { title: "search result" },
    component: () =>
      import(/*webpackChunkName: Movies */ "@/components/Movie/SingleMovieC"),
  },
  {
    path: "/movie/:item",
    meta: { title: "movie" },
    name: "movieproduct",
    component: () =>
      import(/*webpackChunkName: Movies */ "@/components/Movie/MovieProductC"),
  },
  {
    path: "/actors",
    name: "actors",
    meta: { title: "Actors" },
    component: () =>
      import(/*webpackChunkName: Movies */ "@/components/Movie/ActorsC"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});
export default router;
